import {Title} from "@src/components/Title/Title";
import {HistorySvg} from "@src/components/AllSvg/HistorySvg";
import {Button} from "@src/components/Button/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    selectHistoryOrdersDate,
    selectOrdersHistoryNextPage,
    selectOrderStatuses
} from "@src/store/ducks/orders/selectors";
import {getHistoryAsinc} from "@src/store/ducks/orders/thunks";
import style from "@src/pages/History/History.module.scss";
import React, {useEffect, useState, useMemo} from "react";
import {AppDispatch} from "@src/store/store";
import {TableHistoryElem} from "@src/pages/History/TableHistoryElem/TableHistoryElem";
import {OrdersHistoryElemType} from "@src/store/ducks/orders/types";
import cn from "classnames";
import {NavLink} from "react-router-dom";
import {
    resetHistoryDone,
    setSuccessPage,
    setTourChoiseOpen,
    setTourFormalisationOpen
} from "@src/store/ducks/app/reducer";
import logo from "@src/images/logo.svg";
import filter from "@src/images/filter-history.svg"
import burgerClose from "@src/images/burger-close.svg";
import {selectUserInfo} from "@src/store/ducks/user/selectors";
import {selectResetHistoryFilter} from "@src/store/ducks/app/selectors";
import * as Yup from "yup";
import {Form, Formik} from "formik";
import {FieldFormik} from "@src/components/common/FieldFormik/FieldFormik";
import {Clear} from "@src/components/AllSvg/Clear";


type HistoryFiltersType = {
    number: string,
    fio: string,
}

const emptyFilters: HistoryFiltersType = {
    number: '',
    fio: '',
}

const toApiFilter = (value: string) => {
    const trimmed = String(value ?? '').trim()
    return trimmed || null
}


export const History = () => {
    const user = useSelector(selectUserInfo)
    const dispatch = useDispatch<AppDispatch>()
    const orderStatuses = useSelector(selectOrderStatuses)
    const [activeButton, setActiveButton] = useState(1);
    const historyData = useSelector(selectHistoryOrdersDate)
    const [openMobileTabs, setOpenMobileTabs] = useState(false)
    const [mobileTitle, setMobileTitle] = useState("Все")
    const [appliedFilters, setAppliedFilters] = useState<HistoryFiltersType>(emptyFilters)

    const fetchHistory = (status: number, filters: HistoryFiltersType = appliedFilters) => {
        dispatch(getHistoryAsinc(
            status,
            user.id,
            1,
            toApiFilter(filters.number),
            toApiFilter(filters.fio), true
        ))
        setCurrentPage(currentPage + 1)
    }
    let nextPage = useSelector(selectOrdersHistoryNextPage)

    const [valuesForHistory, setValuesForHistory] = useState<any>({
        status: activeButton,
        id: user.id,
        page: 1,
    })

    const resetFlag = useSelector(selectResetHistoryFilter);

    useEffect(() => {
        if (resetFlag) {
            resetToFirstButton();
            dispatch(resetHistoryDone());
        }
    }, [resetFlag]);

    useEffect(() => {
        setValuesForHistory((prevValues: any) => ({
            ...prevValues,
            id: user.id, // обновляем только id, остальные параметры оставляем без изменений
        }));
    }, [user.id]); // Хук срабатывает, когда user.id изменяется


    const handleClick = (buttonId: number) => {
        setCurrentPage(1)
        setActiveButton(buttonId);
        setValuesForHistory((prevState: any) => ({
            ...prevState, // Сохраняем остальные значения
            status: buttonId, // Обновляем только статус
        }));
    };

    const [fetching, setFetching] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const [allowLoading, setAllowLoading] = useState(false)


    useEffect(() => {
        setFetching(false)
    }, []);


    useEffect(() => {
        updatePropertyValue(Number(nextPage))
    }, [nextPage, allowLoading]);

    const updatePropertyValue = (currentPage: number) => {
        if (valuesForHistory) {
            setValuesForHistory({
                ...valuesForHistory,
                // Создаем копию объекта
                page: currentPage    // Обновляем значение одного свойства
            });
        }
    };

    useEffect(() => {
        if (fetching && nextPage !== 0) {
            try {
                if (nextPage !== currentPage) {
                    dispatch(getHistoryAsinc(valuesForHistory.status, valuesForHistory.id, valuesForHistory.page,
                        toApiFilter(appliedFilters.number),
                        toApiFilter(appliedFilters.fio)))
                    setCurrentPage(currentPage + 1)
                }
            } finally {
                setFetching(false)
            }
        }
    }, [fetching])


    useEffect(() => {
        document.body.addEventListener('scroll', () => scrollHandler());

        return function () {
            document.body.removeEventListener('scroll', () => scrollHandler());
        }
    }, [activeButton]);

    const scrollHandler = () => {
        let scrollTop = document.body.scrollTop;
        let totalHeight = document.body.scrollHeight;
        let windowHeight = window.innerHeight;
        if (totalHeight - (scrollTop + windowHeight) <= 50 && nextPage !== 0) {
            setFetching(true);
        }
    }

    // функция полного сброса
    const resetToFirstButton = () => {
        dispatch(getHistoryAsinc(1, user.id, 1, toApiFilter(appliedFilters.number),
            toApiFilter(appliedFilters.fio)));
        handleClick(1)
        setMobileTitle(orderStatuses[1])
        setOpenMobileTabs(false)
    };

    const validationSchema = useMemo(() => (
        Yup.object().shape({})
    ), [])

    const initialValues = useMemo(() => ({
        number: '',
        fio: '',
    }), [])

    return (
        <div className={style['history-wrapper']}>
            <Title title={'История'} svgComponent={HistorySvg}></Title>
            <Formik
                initialValues={initialValues}
                onSubmit={(values) => {
                    const filters = {
                        number: values.number,
                        fio: values.fio,
                    }
                    setAppliedFilters(filters)
                    fetchHistory(activeButton, filters)
                    setOpenMobileTabs(false)
                }}
                onReset={() => {
                    setAppliedFilters(emptyFilters)
                    fetchHistory(activeButton, emptyFilters)
                }}
                validationSchema={validationSchema}
            >
                {({resetForm}) => (
                    <Form className={style.form}>
                        <div className={style.filter} onClick={() => setOpenMobileTabs(!openMobileTabs)}>
                            <img src={filter} alt={filter}/>
                            {mobileTitle}
                        </div>
                        <div className={style.historyFilters}>
                            <FieldFormik
                                name="number"
                                placeholder="Номер заказа"
                                className={style.filterOrderNumber}
                                typeInput="input-select"
                                type="text"
                            />
                            <FieldFormik
                                name="fio"
                                placeholder="ФИО"
                                className={style.filterFio}
                                typeInput="input-select"
                            />
                        </div>
                        <div className={style.blockFilter}>
                            <Button onClickFunc={() => resetForm()} className={style.clearSelect} svgComponent={Clear}>
                                Сбросить фильтры
                            </Button>
                            <Button htmlType="submit" className={'btn-second'}>Применить</Button>
                        </div>
                        <div
                            className={cn(style['tabsStep-mobile'], openMobileTabs ? style['steps-mobile-active'] : '')}>
                            <div className="container">
                                <div className={style['mobile-steps-inner']}>
                                    <div className={style['steps-mb-logo']}>
                                        <NavLink
                                            to="/tours"
                                            onClick={() => {
                                                dispatch(setTourFormalisationOpen(false));
                                                dispatch(setSuccessPage(false));
                                                dispatch(setTourChoiseOpen(true));
                                            }}>
                                            <div className={style.logo}>
                                                <img
                                                    src={logo}
                                                    alt="logo"
                                                />
                                            </div>
                                        </NavLink>
                                    </div>
                                    <div className={style.burger}>
                                        <div onClick={() => setOpenMobileTabs(false)} className={style['burger-close']}>
                                            <img
                                                src={burgerClose}
                                                alt="burger-close"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={style['tabsStep-mobile-title']}>Фильтрация заказов</div>
                                <div className={style.historyFilters}>
                                    <FieldFormik
                                        name="number"
                                        placeholder="Номер заказа"
                                        className={style.filterOrderNumber}
                                        typeInput="input-select"
                                        type="text"
                                    />
                                    <FieldFormik
                                        name="fio"
                                        placeholder="ФИО"
                                        className={style.filterFio}
                                        typeInput="input-select"
                                    />
                                </div>
                                <div className={style.blockFilter}>
                                    <Button onClickFunc={() => resetForm()} className={style.clearSelect}
                                            svgComponent={Clear}>
                                        Сбросить фильтры
                                    </Button>
                                    <Button htmlType="submit" className={'btn-second'}>Применить</Button>
                                </div>
                                <div className={style.tabs}>
                                    {orderStatuses && Object.keys(orderStatuses).map((key) => (
                                        <Button key={key} onClickFunc={() => {
                                            dispatch(getHistoryAsinc(+key, user.id, 1, toApiFilter(appliedFilters.number),
                                                toApiFilter(appliedFilters.fio)));
                                            handleClick(+key)
                                            setMobileTitle(orderStatuses[key])
                                            setOpenMobileTabs(false)
                                        }} className={activeButton === +key ? style.btnActive : style.btnCustom}>
                                            {orderStatuses[key]}
                                        </Button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className={style['tabs-wrapper']}>
                            <div className={style.tabs}>
                                {orderStatuses && Object.keys(orderStatuses).map((key) => (
                                    <Button key={key} onClickFunc={() => {
                                        dispatch(getHistoryAsinc(+key, user.id, 1, toApiFilter(appliedFilters.number),
                                            toApiFilter(appliedFilters.fio)));
                                        handleClick(+key);
                                        setMobileTitle(orderStatuses[key])
                                        document.body.scrollTop = 0;
                                        document.documentElement.scrollTop = 0;
                                        setFetching(false)
                                        setCurrentPage(1)
                                    }} className={activeButton === +key ? style.btnActive : style.btnCustom}>
                                        {orderStatuses[key]}
                                    </Button>
                                ))}
                            </div>
                        </div>
                        <div className={style.tableHistory}>
                            {(historyData && historyData.length !== 0) ? historyData.map((item: OrdersHistoryElemType) => (
                                <TableHistoryElem key={item.id} item={item}/>)) : <span>Нет результатов</span>}
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}


